import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "simplebar-react/dist/simplebar.min.css";
import "flatpickr/dist/themes/light.css";
import "../src/assets/scss/app.scss";
import { BrowserRouter } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import store from "./store";
import "react-toastify/dist/ReactToastify.css";
import {constants} from "@/constants";
import Branding from "@/utils/branding";
import {getSecondLevelDomain} from "./utils/url.js";

let platform = Branding();

if (platform && platform.yaMetricsID) {
    ym(platform.yaMetricsID, "init", {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true,
        webvisor:true
    });
}

const urlParams = new URLSearchParams(window.location.search);
if (urlParams.has("from")) {
  document.cookie = `aff_code=${urlParams.get("from")}; Domain=.${getSecondLevelDomain(window.location.hostname)}; Path=/`;
}

// TODO: убрать форсирование когда будет полоценная тёмная тема
localStorage.setItem("theme", "light")

ReactDOM.createRoot(document.getElementById("root")).render(
  <>
    <BrowserRouter basename={constants.baseURL}>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </>
);
